// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bluetooth-off.js';

import { paths } from '../generated/bluetooth-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bluetooth-off', Original, paths);
